/**
 * Time Zone
 *
 * Supported IANA time zone identifiers.
 */
export const TimeZone = {
  // UTC
  UTC: 'UTC',

  // Europe
  EUROPE_PRAGUE: 'Europe/Prague',
  EUROPE_BRATISLAVA: 'Europe/Bratislava',
  EUROPE_VIENNA: 'Europe/Vienna',
  EUROPE_WARSAW: 'Europe/Warsaw',
  EUROPE_BUDAPEST: 'Europe/Budapest',
  EUROPE_BUCHAREST: 'Europe/Bucharest',
  EUROPE_BERLIN: 'Europe/Berlin',
  EUROPE_LONDON: 'Europe/London',
  EUROPE_DUBLIN: 'Europe/Dublin',
  EUROPE_PARIS: 'Europe/Paris',
  EUROPE_ROME: 'Europe/Rome',
  EUROPE_MADRID: 'Europe/Madrid',
  EUROPE_AMSTERDAM: 'Europe/Amsterdam',
  EUROPE_BRUSSELS: 'Europe/Brussels',
  EUROPE_LISBON: 'Europe/Lisbon',
  EUROPE_ZURICH: 'Europe/Zurich',
  EUROPE_STOCKHOLM: 'Europe/Stockholm',
  EUROPE_HELSINKI: 'Europe/Helsinki',
  EUROPE_OSLO: 'Europe/Oslo',
  EUROPE_COPENHAGEN: 'Europe/Copenhagen',
  EUROPE_ATHENS: 'Europe/Athens',
  EUROPE_ISTANBUL: 'Europe/Istanbul',
  EUROPE_KYIV: 'Europe/Kyiv',
  EUROPE_MOSCOW: 'Europe/Moscow',
  EUROPE_ZAGREB: 'Europe/Zagreb',
  EUROPE_SOFIA: 'Europe/Sofia',
  EUROPE_VILNIUS: 'Europe/Vilnius',
  EUROPE_RIGA: 'Europe/Riga',
  EUROPE_TALLINN: 'Europe/Tallinn',
  EUROPE_LUXEMBOURG: 'Europe/Luxembourg',
  EUROPE_BELGRADE: 'Europe/Belgrade',

  // Americas
  AMERICA_NEW_YORK: 'America/New_York',
  AMERICA_CHICAGO: 'America/Chicago',
  AMERICA_DENVER: 'America/Denver',
  AMERICA_LOS_ANGELES: 'America/Los_Angeles',
  AMERICA_TORONTO: 'America/Toronto',
  AMERICA_VANCOUVER: 'America/Vancouver',
  AMERICA_SAO_PAULO: 'America/Sao_Paulo',
  AMERICA_MEXICO_CITY: 'America/Mexico_City',
  AMERICA_BOGOTA: 'America/Bogota',
  AMERICA_LIMA: 'America/Lima',
  AMERICA_SANTIAGO: 'America/Santiago',
  AMERICA_BUENOS_AIRES: 'America/Argentina/Buenos_Aires',

  // Asia / Middle East
  ASIA_DUBAI: 'Asia/Dubai',
  ASIA_RIYADH: 'Asia/Riyadh',
  ASIA_KOLKATA: 'Asia/Kolkata',
  ASIA_DHAKA: 'Asia/Dhaka',
  ASIA_BANGKOK: 'Asia/Bangkok',
  ASIA_SINGAPORE: 'Asia/Singapore',
  ASIA_KUALA_LUMPUR: 'Asia/Kuala_Lumpur',
  ASIA_HONG_KONG: 'Asia/Hong_Kong',
  ASIA_SHANGHAI: 'Asia/Shanghai',
  ASIA_TAIPEI: 'Asia/Taipei',
  ASIA_TOKYO: 'Asia/Tokyo',
  ASIA_SEOUL: 'Asia/Seoul',
  ASIA_JAKARTA: 'Asia/Jakarta',
  ASIA_JERUSALEM: 'Asia/Jerusalem',
  ASIA_MANILA: 'Asia/Manila',
  ASIA_HO_CHI_MINH: 'Asia/Ho_Chi_Minh',

  // Africa
  AFRICA_JOHANNESBURG: 'Africa/Johannesburg',
  AFRICA_CAIRO: 'Africa/Cairo',
  AFRICA_LAGOS: 'Africa/Lagos',
  AFRICA_NAIROBI: 'Africa/Nairobi',

  // Pacific / Oceania
  AUSTRALIA_SYDNEY: 'Australia/Sydney',
  AUSTRALIA_MELBOURNE: 'Australia/Melbourne',
  AUSTRALIA_PERTH: 'Australia/Perth',
  PACIFIC_AUCKLAND: 'Pacific/Auckland',
  PACIFIC_HONOLULU: 'Pacific/Honolulu'
} as const;

export type TimeZone = (typeof TimeZone)[keyof typeof TimeZone];
